if (!customElements.get('klaviyo-waitlist')) {
  customElements.define(
    'klaviyo-waitlist',
    class KlaviyoWaitlist extends HTMLElement {
      constructor() {
        super();

        this.productInfo = this.closest('product-info');
        this.klaviyoWaitlist = this.productInfo?.querySelector('klaviyo-waitlist');
        this.productForm = this.productInfo?.querySelector('product-form');
        this.waitlistButton = this.querySelector('.pv__waitlist');
        this.waitlistButton.addEventListener('click', this.onSubmitHandler.bind(this));
        this.waitlistEmail = this.querySelector('.product__klaviyo-email');
      }

      onSubmitHandler() {
        // check validity of email
        if (!this.waitlistEmail.checkValidity()) {
          this.waitlistEmail.reportValidity();
          return;
        }
        this.waitlistButton = this.querySelector('.pv__waitlist');
        this.handleKlaviyoSubmit(this.productInfo, this.waitlistButton);
      }

      showSuccessState() {
        // Add success class to show green background and check icon
        this.waitlistButton.classList.add('success');
      }

      toggleWaitlistButton(waitlist = true) {
        if (waitlist) {
          this.klaviyoWaitlist.classList.remove('hide');
          this.productForm.classList.add('hide');
        } else {
          this.klaviyoWaitlist.classList.add('hide');
          this.productForm.classList.remove('hide');
        }
      }

      async handleKlaviyoSubmit($productInfo, $btn) {
        const email = $productInfo.querySelector('.product__klaviyo-email')?.value;

        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            revision: '2025-07-15',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                    },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${$btn.dataset?.productId}`,
                  },
                },
              },
            },
          }),
        };

        const companyId = await klaviyo.account(); // eslint-disable-line
        await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${companyId}`, options)
          .catch((err) => console.error(err));

        this.showSuccessState();
      }
    },
  );
}
